import { c as _c } from "react/compiler-runtime";
import { ArrowNarrowLeftIcon } from '@systemeio/icons';
import RuleSave from 'modules/automation-rules/components/rule-save';
import { useAutomationRule } from 'modules/automation-rules/hooks/use-automation-rule';
import { useRuleState } from 'modules/automation-rules/hooks/use-rule-state';
import { SpecificTriggerRulesProps } from 'modules/automation-rules/specific-trigger-rules';
import { AutomationRuleTriggersEnum } from 'modules/automation-rules/triggers/enums/trigger-enum';
import { AutomationRuleApiInterface, AutomationRuleViewInterface } from 'modules/automation-rules/types/automation-rule-interface';
import { useEffect, useRef, useState } from 'react';
import { Button } from 'shared/components';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import useMediaQuery from 'shared/hooks/use-media-query';
import { CONTENT_HORIZONTAL_PADDING_CLASSNAME } from 'shared/layout/constants/layout-class-names';
import { KeyedMutator } from 'swr';
import { twJoin } from 'tailwind-merge';
import { SpecificTriggerRule } from './specific-trigger-rule';
interface SpecificTriggerRuleEditProps extends Pick<SpecificTriggerRulesProps, 'getRelatedAndUnrelatedTriggersData' | 'customAddTriggerHandler' | 'noRelatedMessage'> {
  ruleId: number;
  clearSelectedRule: () => void;
  availableTriggers?: AutomationRuleTriggersEnum[];
  mutateRules: KeyedMutator<AutomationRuleApiInterface>;
  mutateAvailableTriggers: KeyedMutator<AutomationRuleTriggersEnum[]>;
}
const SpecificTriggerRuleEdit = t0 => {
  const $ = _c(52);
  const {
    ruleId,
    clearSelectedRule,
    mutateRules,
    mutateAvailableTriggers,
    availableTriggers,
    getRelatedAndUnrelatedTriggersData,
    customAddTriggerHandler,
    noRelatedMessage
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const {
    isMobile
  } = useMediaQuery();
  const {
    data: rule,
    mutate
  } = useAutomationRule(ruleId);
  const [isFetching, setIsFetching] = useState(false);
  const {
    tempState,
    setTempState,
    errors,
    setErrors
  } = useRuleState();
  const maxTriggerId = useRef(0);
  const maxActionId = useRef(0);
  let t1;
  let t2;
  if ($[0] !== rule || $[1] !== setTempState) {
    t1 = () => {
      if (rule) {
        setTempState(prev => ({
          ...prev,
          ...rule
        }));
        if (rule.actions.length !== 0) {
          maxActionId.current = Math.max(...rule.actions.map(_temp));
        }
      }
    };
    t2 = [rule, setTempState];
    $[0] = rule;
    $[1] = setTempState;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  let t3;
  if ($[4] !== clearSelectedRule || $[5] !== mutate || $[6] !== mutateAvailableTriggers || $[7] !== mutateRules) {
    t3 = async rule_0 => {
      await mutate(data => ({
        ...data,
        ...rule_0
      }));
      await mutateRules();
      await mutateAvailableTriggers();
      clearSelectedRule();
    };
    $[4] = clearSelectedRule;
    $[5] = mutate;
    $[6] = mutateAvailableTriggers;
    $[7] = mutateRules;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const afterSave = t3;
  let t4;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <ArrowNarrowLeftIcon />;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t) {
    t5 = t("dashboard.funnel.automation_rules.back");
    $[10] = t;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== clearSelectedRule || $[13] !== isFetching || $[14] !== t5) {
    t6 = <Button disabled={isFetching} className="w-fit" onClick={clearSelectedRule} variant="ghost-gray" size="sm">{t4}{t5}</Button>;
    $[12] = clearSelectedRule;
    $[13] = isFetching;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== afterSave || $[17] !== isFetching || $[18] !== ruleId || $[19] !== setErrors || $[20] !== tempState) {
    t7 = <RuleSave className="tablet:flex hidden" afterSave={afterSave} isFetching={isFetching} setIsFetching={setIsFetching} rule={tempState} ruleId={ruleId} setErrors={setErrors} size="md" />;
    $[16] = afterSave;
    $[17] = isFetching;
    $[18] = ruleId;
    $[19] = setErrors;
    $[20] = tempState;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  let t8;
  if ($[22] !== t6 || $[23] !== t7) {
    t8 = <div className="flex items-center justify-between gap-4">{t6}{t7}</div>;
    $[22] = t6;
    $[23] = t7;
    $[24] = t8;
  } else {
    t8 = $[24];
  }
  const t9 = !rule;
  const t10 = rule?.triggers;
  let t11;
  if ($[25] !== availableTriggers || $[26] !== customAddTriggerHandler || $[27] !== errors || $[28] !== getRelatedAndUnrelatedTriggersData || $[29] !== isFetching || $[30] !== noRelatedMessage || $[31] !== ruleId || $[32] !== setTempState || $[33] !== t10 || $[34] !== t9 || $[35] !== tempState) {
    t11 = <SpecificTriggerRule noRelatedMessage={noRelatedMessage} ruleId={ruleId} isFetching={isFetching} availableTriggers={availableTriggers} tempState={tempState} setTempState={setTempState} errors={errors} maxTriggerId={maxTriggerId} maxActionId={maxActionId} isPreFetching={t9} savedTriggers={t10} getRelatedAndUnrelatedTriggersData={getRelatedAndUnrelatedTriggersData} customAddTriggerHandler={customAddTriggerHandler} />;
    $[25] = availableTriggers;
    $[26] = customAddTriggerHandler;
    $[27] = errors;
    $[28] = getRelatedAndUnrelatedTriggersData;
    $[29] = isFetching;
    $[30] = noRelatedMessage;
    $[31] = ruleId;
    $[32] = setTempState;
    $[33] = t10;
    $[34] = t9;
    $[35] = tempState;
    $[36] = t11;
  } else {
    t11 = $[36];
  }
  const t12 = isMobile && CONTENT_HORIZONTAL_PADDING_CLASSNAME;
  let t13;
  if ($[37] !== t12) {
    t13 = twJoin("bg-bg-primary border-border-100 tablet:hidden fixed inset-x-0 bottom-0 z-40 flex border-t py-4", t12);
    $[37] = t12;
    $[38] = t13;
  } else {
    t13 = $[38];
  }
  let t14;
  if ($[39] !== afterSave || $[40] !== isFetching || $[41] !== ruleId || $[42] !== setErrors || $[43] !== tempState) {
    t14 = <RuleSave className="w-full" afterSave={afterSave} isFetching={isFetching} setIsFetching={setIsFetching} rule={tempState} ruleId={ruleId} setErrors={setErrors} size="md" />;
    $[39] = afterSave;
    $[40] = isFetching;
    $[41] = ruleId;
    $[42] = setErrors;
    $[43] = tempState;
    $[44] = t14;
  } else {
    t14 = $[44];
  }
  let t15;
  if ($[45] !== t13 || $[46] !== t14) {
    t15 = <div className={t13}>{t14}</div>;
    $[45] = t13;
    $[46] = t14;
    $[47] = t15;
  } else {
    t15 = $[47];
  }
  let t16;
  if ($[48] !== t11 || $[49] !== t15 || $[50] !== t8) {
    t16 = <div className="tablet:pb-0 flex flex-col gap-4 pb-18">{t8}{t11}{t15}</div>;
    $[48] = t11;
    $[49] = t15;
    $[50] = t8;
    $[51] = t16;
  } else {
    t16 = $[51];
  }
  return t16;
};
export default SpecificTriggerRuleEdit;
function _temp(el) {
  return el.id;
}